import Vue from "vue";
import "normalize.css";
import "_private/element";
import "_private/components/wooden/theme/index.scss";
import "_private/assets/styles/index.scss";
import "_private/permission";
import E6Ui from "_private/components/wooden";
import "_private/directives";

Vue.use(E6Ui);
